const SOCIAL_MEDIA_DATA = {
    "linkedin" : {
        url: "https://www.linkedin.com/in/muhammad-abubakar-795b45252/",
        icon: "linkedin"
    },
    "github" : {
        url: "https://github.com/25abubakar",
        icon: "github"
    },
    "hackerrank" : {
        url: "https://www.hackerrank.com/muhammadabubak21",
        icon: "hackerrank"
    },
    "medium" : {
        url: "https://medium.com/@muhammadabubakarkhan1234",
        icon: "medium"
    },
    "facebook": {
        url: "https://www.facebook.com/abubakarchughtai25",
        icon: "facebook"
    }
};

export default SOCIAL_MEDIA_DATA;
